import { encode as base64_encode, decode as base64_decode } from "base-64";

import config from "../config";
import { postApi } from "../components/Utility";
import utf8 from "utf8";
import Cookies from "js-cookie";
import moment from "moment";

import { action, makeObservable, observable } from "mobx";

class VehicleStore {
  total = 0;
  loading = false;
  logoFromDb = [];
  vehicles = [];
  assetVehicleList = [];
  getSCategories = [];
  getVehiclesUsingCompanyId = [];
  getTypeofCategory = [];
  getpollimie = [];
  getWeightUsingtId = [];
  searchdata = [];
  deviceGroups = [];
  getDeviceGroupsVehicles = [];
  vehicleRules = [];
  fuelDetails = [];
  groupList = [];
  rootStore;
  fileUploadUrl = "/vehicle/fileupload";

  constructor(rootStore) {
    makeObservable(this, {
      vehicles: observable,
      logoFromDb: observable,
      total: observable,
      searchdata: observable,
      deviceGroups: observable,
      getDeviceGroupsVehicles: observable,
      vehicleRules: observable,
      fuelDetails: observable,
      groupList: observable,
      loadData: action,

      loading: observable,
      // loadStatusData: action,
      getVehicleData: action,
      getVehicles: action,
      addData: action,
      deleteRecord: action,
      getTrailerDetails: action,
      getSFDACategories: action,
      getTypeByCategory: action,
      renewVehicle: action,
      setLogoFromDb: action,
      getWeightBytId: action,
      getVehicleGroups: action,
      getDeviceGroups: action,
      sampleExcel: action,
      addVehicleByExcel: action,
      getVehicleRules: action,
      getFuelCaliDetails: action,

      getVehicleGroup: action,
      getVehicleSubGroup: action,
      fileUploadUrl: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    searchField,
    status,
    isadmin,
    userId,
    usercompanyId,
  }) {
    this.loading = true;

    var postData = {
      // usercompanyId: "1",
      companyId: companyId,
      isadmin: isadmin,
      userId: userId,
      offset: offset,
      limit: limit,
      searchField: searchField,
      status: status,
      usercompanyId,
    };
    //const base64Input = await base64_encode(JSON.stringify(postData));
    // const base64Input = await utf8.encode(JSON.stringify(postData));
    // const base2 = JSON.stringify(base64_encode(base64Input));

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/vehicledetails", {
        params: postData,
      });

    this.vehicles = response?.data?.vehicleData;
    this.total = parseInt(response?.data?.TotalCount);

    this.loading = false;
  }

  async addData(data) {
    var postData = data.vehicle;
    // var postData = vehicle;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=update", "postData=" + base64Input);
    // console.log(response);

    var vehicleData = { postData };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("vehicle/updateVehicle", vehicleData);

    return response;
  }
  //For Groups in live tracking
  async getVehicleGroups(companyId, userId, isadmin) {
    var postData = { companyId, userId, isadmin };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=user&a=getusergroupvehiclesnew",
        "postData=" + base64Input
      );

    return response;
  }

  async getVehicleData(vehicleId) {
    console.log(vehicleId, "id");
    const postData = { vehicleId: vehicleId, limit: 1, offset: 0 };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/vehicledetails", {
        params: postData,
      });
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=vehicledetails", "postData=" + base64Input);
    // console.log(response);

    var singleRow = response?.data?.vehicleData[0];
    // console.log(singleRow);
    //this.logoFromDb.disabled = true;

    if (singleRow.icon) {
      console.log(config.fleetURL + "/images/vehicles/" + singleRow.icon);

      const fileList = [
        {
          name: singleRow.icon,
          status: "success",
          url: config.fleetURL + "/images/vehicles/" + singleRow.icon,
        },
      ];
      this.setLogoFromDb(fileList);
      console.log(fileList, "filelist");
      //  }
    }

    // return response?.data?.data?.vehicledetails[0];
    return singleRow;
  }

  // use For DropDown Asset

  async getVehicles(companyId) {
    var postData = {
      tokenId: "80bovn8u800tg1aq9bvr73kbhh",
      usercompanyId: 1,
      companyId: companyId,
      isadmin: -1,
      offset: 0,
      limit: 100,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=vehicledetails", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/vehicledetails", {
        params: postData,
      });
    let allVehicles = [{ vehicleId: 0, vehicleNo: "ALL" }];
    allVehicles = [...allVehicles, ...response?.data?.vehicleData];
    this.assetVehicleList = allVehicles;
    return response?.data?.vehicleData;
  }

  async getBusNo(companyId) {
    // console.log("companyId", companyId)
    var postData = {
      tokenId: "80bovn8u800tg1aq9bvr73kbhh",
      usercompanyId: 1,
      companyId: companyId,
      isadmin: -1,
      offset: 0,
      limit: 100,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=vehicledetails", "postData=" + base64Input);
    // console.log(response, "post");
    // let allVehicles = [{ "vehicleId": 0, "vehicleNo": "ALL" }];
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/vehicledetails", {
        params: postData,
      });
    this.assetVehicleList = response?.data?.vehicleData;
    return response?.data?.vehicleData;
  }

  async deleteRecord({ vehicleId, userId, full_imei }) {
    // var postData = {
    //   tokenId: "",
    //   vehicle: { vehicle_id: vehicleId, userId: 1, full_imei: full_imei },
    // };
    var postData = { vehicle_id: vehicleId, userId: 1, full_imei: full_imei };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("vehicle/deleteVehicle", {
        params: postData,
      });
    return response;
  }

  async getCurrentGps(vehicleId) {
    // console.log("vehicle list")
    var postData = { vehicleId: vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=odometer&a=getGpsOdometer", "postData=" + base64Input);
    // console.log(response, "post");

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicleOdoMeter/getGpsOdometer", { params: postData });
    return response?.data?.data;
  }

  async getOdometerByTime(vehicleId, datetime) {
    // console.log("vehicle list")
    var postData = { datetime: datetime, vehicleId: vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=odometer&a=findOdometerByTime",
        "postData=" + base64Input
      );
    console.log(response, "post");
    return response?.data?.data;
  }
  async getPollingImeiData() {
    // console.log("vehicle list")
    // var postData = null;
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getpollimei");
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getpollimie", "postData=" + base64Input);
    // console.log(response?.data?.data[0], "post");

    this.getpollimie = response?.data?.data;
    return response?.data?.data;
  }

  // getVehicle Service use in reports
  // async getVehiclesCompanyId({ companyId }) {
  async getVehiclesCompanyId(companyId) {
    console.log("companyId" + companyId);
    // var postData = { companyId: "96" };
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    // console.log(response, "post");
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: postData });
    this.getVehiclesUsingCompanyId = response?.data?.vehicleData;

    return response?.data?.vehicleData;
  }

  async getDeliveryVehicles(companyId) {
    var postData = { companyId: companyId, isDelivery: 1 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

    // this.getVehiclesUsingCompanyId = response?.data?.data;

    // return response?.data?.data;

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: postData });
    this.getVehiclesUsingCompanyId = response?.data?.vehicleData;

    return response?.data?.vehicleData;
  }

  // To get Attach Trailer Dropdown
  async getTrailerDetails(companyId, vehicleId) {
    // console.log("vehicle list")
    var postData = { companyId: companyId, vehicleId: vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=trailer&a=getTrailers", "postData=" + base64Input);
    // console.log(response?.data?.data, "post")
    this.getTrailerUsingCompanyId = response?.data?.data;
    return response?.data?.data;
  }

  async getWeightBytId(tId) {
    // console.log("vehicle list")
    var postData = { tId: tId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=trailer&a=getWeightBytId", "postData=" + base64Input);
    console.log(response, "post");
    this.getWeightUsingtId = response?.data?.data;
    return response?.data?.data;
  }

  //To get Storing Category
  async getSFDACategories() {
    // console.log("vehicle list")
    var postData = null;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=inventory&a=getSCategories",
        "postData=" + base64Input
      );
    // console.log(response?.data?.data, "post")
    this.getSCategories = response?.data?.data;
    return response?.data?.data;
  }

  async getTypeByCategory(categoryId) {
    // console.log("vehicle list")
    var postData = { categoryId: categoryId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=inventory&a=getTypeByCategory",
        "postData=" + base64Input
      );
    console.log(response, "post");
    this.getTypeofCategory = response?.data?.data;
    return response?.data?.data;
  }

  async renewVehicle(renewData) {
    // console.log("vehicle list")
    // var postData = renewData;
    // const vehicleIds = renewData.;
    // const renewValue = ;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .put("vehicle/renewVehicles", {
        renewData,
      });
    return response;
  }

  async setLogoFromDb(logo) {
    this.logoFromDb = { fileList: logo };
  }

  async exportExcel(getData) {
    try {
      var response = await postApi
        .getClient("NodeCoreUrl")
        .post("vehicle/exportVehicleExcel", getData, {
          responseType: "blob",
        });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Vehicle Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
    // window.location.href =
    //   config.baseURL +
    //   "index.php?c=vehicle&a=vehicleExportexcel&cid=" +
    //   getData.cid +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&UcompanyId=" +
    //   getData.UcompanyId +
    //   "&status=" +
    //   getData.status +
    //   "&searchField=" +
    //   getData.searchField +
    //   "&colList=" +
    //   getData.colList;
  }

  async updateStatus(data) {
    console.log(data); //update active in-active
    // var postData = data;
    const vehicleId = data.vehicleId;
    const activeStatus = data.activeStatus;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .patch(
        "vehicle/updateStatus",
        { status: activeStatus },
        { params: { vehicleId } }
      );
    // var response = await postApi.getClient('NodeCoreUrl').post("index.php?c=vehicle&a=updateActive", "postData=" + base64Input);
    return response.data;
  }

  async getDeviceGroups(companyId) {
    console.log(companyId);
    var postData = { companyId: companyId, offset: -1, limit: -1, page: 1 };
    var response = await postApi.getClient().get("deviceGroup/getUserDeviceGroups", { params: postData });
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=company&a=getDeviceGroups", "postData=" + base64Input);
    this.deviceGroups = response.data.deviceGroupData;
    // this.deviceGroups = response.data.data.devicegroups;
    return response.data.deviceGroupData;
  }

  async getDeviceGroupsofVehicles({ deviceGroupId, companyId, userId }) {
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: "1",
      groupNameId: deviceGroupId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getGrpvehicles", "postData=" + base64Input);
    this.getDeviceGroupsVehicles =
      response?.data?.data?.getDeviceGroupsVehicles;

    this.getVehiclesUsingCompanyId =
      response?.data?.data?.getDeviceGroupsVehicles;
    return response.data.data.getDeviceGroupsVehicles;
  }

  // async sampleExcel() {
  //   window.location.href = config.fleetURL + "/appRes/sampleVehicle.xlsx";
  // }

  async sampleExcel() {
    let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;
    if (isadmin == 1) {
      window.location.href = config.fleetURL + "/appRes/sampleVehicle.xlsx";
    } else {
      window.location.href = config.fleetURL + "/appRes/vehicle.xlsx";
    }
  }

  async addVehicleByExcel(excelFile) {
    console.log(excelFile);
    this.excelLoadig = true;
    var postData = excelFile;

    const base64Input = await base64_encode(JSON.stringify(postData));
    let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;
    console.log(isadmin);
    if (isadmin == 1) {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicle&a=importVehicleInsert",
          "postData=" + base64Input
        );
    } else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicle&a=importVehicleNew",
          "postData=" + base64Input
        );
    }

    this.excelLoadig = false;
    return response.data;
  }

  async getVehicleRules(companyId) {
    console.log(companyId);
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getRules", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getRules", { params: postData });
    this.vehicleRules = response.data.data;
    return response.data.data;
  }

  async getFuelCaliDetails() {
    var postData = null;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("fuelCalibration/getFuelCalibrationDetails");
    this.fuelDetails = response?.data?.data;
    return response?.data?.data;
  }

  async getVehicleGroup({ companyId, userId, isadmin }) {
    var postData = { companyId: companyId, userId: userId, isadmin: isadmin };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=devicegroup&a=getVehicleGropups",
    //     "postData=" + base64Input
    //   );

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("/deviceGroup/getVehicleGroups", {
        params: postData,
      });
    this.groupList = response.data.VehicleGroupData;

    return response;
  }

  async getVehicleSubGroup({
    deviceGroupId,
    deviceSubGroupId,
    companyId,
    userId,
    isadmin,
    subgroup,
  }) {
    var postData = {
      deviceGroupId: deviceGroupId,
      deviceSubGroupId: deviceSubGroupId,
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=devicegroup&a=getGroups", "postData=" + base64Input);

     var response = await postApi.getClient().get("/deviceGroup/getReportSubGroupAndVehicle", { params: postData });

    if (subgroup) {
      this.subGroupList = response.data.data[0]?.subgroup;
      this.getVehiclesUsingCompanyId = response.data.data[0]?.vehicles;
    } else {
      this.vehicles = response.data.data[0]?.vehicles;
      this.getVehiclesUsingCompanyId = response.data.data[0]?.vehicles;
    }

    return response.data.data[0]?.vehicles;
  }
}

export default VehicleStore;
